import { getEnv } from "@yuntoo/fetch";
import { registerModels, createClient } from "@lovrabet/sdk";
import { getAppInfo } from "@/services";

const env = getEnv() || "online";

// /**
//  * 将下划线命名转换为驼峰命名
//  * @param str 下划线格式的字符串，如 "premium_payments"
//  * @returns 驼峰格式的字符串，如 "premiumPayments"
//  */
// function snakeToCamel(str: string): string {
//   if (!str) return str;
//   return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
// }

async function fetchModelConfigs() {
  const { appCode, datasets } = await getAppInfo();

  /**
   * 根据文档约定构造models结构: https://qizhiyuntu.feishu.cn/wiki/Hsmwwka1UiagtukZwV2cf7QynEb
   * 示例: https://codeup.aliyun.com/yuntoo/popotang/sdk-model-demo/blob/main/src/api/api.ts
   * models目标结构示例
   * const models: [
   *   {
   *     datasetCode: "e2c0ea6190fb47bf9b4db4afd2b92261",
   *     tableName: "dataset_b92261",
   *   }
   * ]
   */
  const models = datasets.map(({ code, source, tableName }) => {
    if (!tableName && source === "METADATA") {
      tableName = `dataset_${code.slice(-6)}`;
    }
    return {
      datasetCode: code,
      tableName,
      alias: tableName, // 别名, 兼容一下之前的写法
    };
  });

  return { appCode, models };
}

const registerSdk = (async () => {
  const config = await fetchModelConfigs();

  registerModels(config);
  const client = createClient();
  client.setEnvironment(env !== "online" ? "daily" : "online");

  return client;
})();

export { registerSdk };
